import { Box, BoxProps, forwardRef } from '@chakra-ui/react'
import { Helmet } from 'react-helmet-async'
import { Link as RouterLink } from 'react-router-dom'

import { PageHeading, PageHeadingProps } from '../components/page-heading'
import { PageLayout } from '../components/page-layout'
import { ResponsiveContainer } from '../components/responsive-container'
import { SearchResults, SearchResultsSkeleton } from '../components/search-results'
import { TabButton, TabList } from '../components/tab-list'

import { DEFAULT_PAGE_TITLE, useSearchResults } from '../lib'
import { MENUS_ROUTE } from './menus'
import { FAVOURITES_ROUTE } from './favourites'

export const REGULARS_ROUTE = '/regulars'

const REGULARS_FILTERS = [
  {
    key: 'is_regularly_ordered',
    value: 'true',
  },
]

const RegularsPageContent = forwardRef<BoxProps, 'div'>((props, ref) => {
  const { totalCount, isLoadingInitial, ...searchProps } = useSearchResults(REGULARS_FILTERS)

  return (
    <Box ref={ref} {...props}>
      <TabList>
        <TabButton as={RouterLink} to={REGULARS_ROUTE} isActive={true}>
          Regulars
        </TabButton>
        <TabButton as={RouterLink} to={MENUS_ROUTE}>
          Lists
        </TabButton>
        <TabButton as={RouterLink} to={FAVOURITES_ROUTE}>
          Favourites
        </TabButton>
      </TabList>

      {isLoadingInitial && (
        <>
          <SearchResultsSkeleton mt={28} />
        </>
      )}
      {!isLoadingInitial && (
        <>
          {totalCount > 0 && <SearchResults {...searchProps} />}
          {!totalCount && (
            <Box textAlign="center" p={16}>
              You have not yet added any regularly ordered products.
            </Box>
          )}
        </>
      )}
    </Box>
  )
})

const RegularsPageHeader = forwardRef<PageHeadingProps, 'div'>((props, ref) => {
  return (
    <PageHeading ref={ref} {...props} as="div">
      <Box display="flex" justifyContent="space-between">
        <Box as="h1" mr={4}>
          Regulars
        </Box>
      </Box>
    </PageHeading>
  )
})

export const RegularsPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>{DEFAULT_PAGE_TITLE}</title>
      </Helmet>
      <PageLayout>
        <ResponsiveContainer>
          <RegularsPageHeader />
          <RegularsPageContent />
        </ResponsiveContainer>
      </PageLayout>
    </>
  )
}
